import { GET_MESSAGE_COUNT_SUCCESS, GET_MESSAGE_COUNT_REQUEST, GET_MESSAGE_COUNT_FAILURE } from "@/redux/actions";
const initialState = {
    data: null,
    loading: false,
    error: null,
};
const getMessageCountReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_MESSAGE_COUNT_SUCCESS:
            return Object.assign(Object.assign({}, state), { loading: false, error: null, data: action.payload });
        case GET_MESSAGE_COUNT_REQUEST:
            return Object.assign({}, state);
        case GET_MESSAGE_COUNT_FAILURE:
            return Object.assign(Object.assign({}, state), { loading: false, error: action.payload });
        default:
            return state;
    }
};
export default getMessageCountReducer;
